import { Box, Button, Stack, Typography } from "@mui/material";
import React, { FC, useState } from "react";
import EmploymentTable from "./Table";
import { PaginationDetails } from "../../interface/api_request";
import { Pagination } from "../Pagination";
import { FilterEmploymentInputs } from "../FilterInputs";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import EmploymentStats from "./employmentStats";
import { employmentStatsProps } from "../../interface/employment";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import AddStaffModal from "./AddStaffModal";
import { useAuth } from "../../hooks/useAuth";
import { apiAddExistingEmployees } from "../../api/employment";

const EmploymentContent: FC<{
  employment_list: any[];
  loading: boolean;
  stats: employmentStatsProps | null;
  setFilterData: React.Dispatch<React.SetStateAction<string>>;
  paginationState: PaginationDetails;
  setPaginationState: React.Dispatch<React.SetStateAction<PaginationDetails>>;
  refetch?: () => void;
}> = ({
  employment_list,
  loading,
  stats,
  paginationState,
  setPaginationState,
  setFilterData,
  refetch,
}) => {
  const [compare, setCompare] = useState(false);
  const [addStaffOpen, setAddStaffOpen] = useState(false);
  const { token } = useAuth();

  const handleAddStaffSuccess = () => {
    refetch?.();
  };

  return (
    <>
      <EmploymentStats stats={stats} />

      <Box
        sx={{
          padding: 3,
          display: "flex",
          flexDirection: "column",
          minHeight: "80vh",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            sx={{ mb: 1 }}
          >
            <Typography
              variant="subtitle2"
              color={"neutral"}
              sx={{ fontWeight: 700, fontFamily: "Inter" }}
            >
              Employment History
            </Typography>

            <Stack direction="row" alignItems="center" gap={1}>
              {/* Add Existing Staff button */}
              <Button
                onClick={() => setAddStaffOpen(true)}
                startIcon={<PersonAddAlt1Icon sx={{ fontSize: 17 }} />}
                variant="contained"
                sx={{
                  height: 36,
                  px: 2,
                  borderRadius: "8px",
                  fontFamily: "Lexend",
                  fontWeight: 600,
                  fontSize: 13,
                  textTransform: "none",
                  background:
                    "linear-gradient(135deg, #2F66F4 0%, #5B8AF7 100%)",
                  boxShadow: "0 4px 12px rgba(47,102,244,0.25)",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #2459E0 0%, #4A7BF5 100%)",
                    boxShadow: "0 6px 16px rgba(47,102,244,0.35)",
                  },
                }}
              >
                Add Existing Staff
              </Button>

              <Button onClick={() => setCompare(!compare)}>
                {compare ? <FilterAltOffIcon /> : <FilterAltIcon />}
              </Button>
            </Stack>
          </Stack>

          <Box
            sx={{
              width: "96%",
              background: "white",
              p: 3,
              mx: "auto",
              boxShadow:
                "0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
            }}
          >
            {compare && (
              <FilterEmploymentInputs
                loading={loading}
                setFilterData={setFilterData}
              />
            )}
            <EmploymentTable data={employment_list} loading={loading} />
          </Box>
        </Box>

        <Box>
          <Pagination
            paginationState={paginationState}
            setPaginationState={setPaginationState}
          />
        </Box>
      </Box>

      <AddStaffModal
        open={addStaffOpen}
        onClose={() => setAddStaffOpen(false)}
        onSuccess={handleAddStaffSuccess}
        token={token}
        apiAddExistingEmployees={apiAddExistingEmployees as any}
      />
    </>
  );
};

export default EmploymentContent;
